
// Import JS Modules
import { builderDispatch } from '../../../_utils/ui';

// -----------------------------------------------------------
//  fireTrackingEvent
// -----------------------------------------------------------
const fireTrackingEvent = function fireTrackingEvent(type) {
  builderDispatch.dispatch({ type });
};

export default fireTrackingEvent;
